import store from '@/store';

const SCROLL_VIEW = 'scroll-view';
const SAVE_POSITION = pathName => `save-position${pathName}`;

export const memorizeScroll = (delay = 10) => {
  const pathName = location.pathname;

  let scroll = document.getElementsByClassName(SAVE_POSITION(pathName))[0]?.scrollTop ?? 0;
  if (scroll !== 0) scroll += 150;
  setTimeout(() => {
    store.commit('layout/appendScroll', { pathName, scroll });
  }, delay);
};

export const recoverScroll = (delay = 100, behavior = 'smooth') => {
  const pathName = location.pathname;
  const scrolls = store.getters['layout/getScroll'];

  // 260523: 옛 코드 `elem => pathName === pathName`은 항상 true라 첫 entry 무조건 pop
  // → 무관한 다른 path scroll로 복원되거나 0으로 떨어짐 (business list 백키 후 맨 위로 가던 원인)
  const scrollIdx = scrolls.findIndex(elem => elem.pathName === pathName);
  if (scrollIdx < 0) return;

  // splice 결과를 보존 후 그 entry의 scroll로 복원 (옛 코드는 splice 후 같은 index access → off-by-one)
  const [target] = scrolls.splice(scrollIdx, 1);
  setTimeout(() => {
    const dom = document.getElementsByClassName(SAVE_POSITION(pathName))[0];
    if (!dom) return;
    dom.scrollTo({ left: 0, top: target?.scroll || 0, behavior });
  }, delay);
  store.commit('layout/memorizeScroll', scrolls);
};

export const scrollLock = () => {
  const scrollSpot = document.getElementsByClassName(SCROLL_VIEW)[0];
  if (!scrollSpot) return;

  const isLock = scrollSpot.style.overflowY === 'hidden';
  if (isLock) scrollSpot.style.overflowY = 'auto';
  else scrollSpot.style.overflowY = 'hidden';
};
export const scrollTop = ($event, behavior = 'smooth') => {
  const scrollSpot = document.getElementsByClassName(SCROLL_VIEW)[0];
  if (!scrollSpot) return;

  scrollSpot.scrollTo({ left: 0, top: 0, behavior: behavior });
};
